import axiosInstance from './axiosInstance'

export const getQuestions = async () => {
  const res = await axiosInstance.get('/questions') 
  return res.data
}
export const createQuestion = async (question) => {
  const res = await axiosInstance.post('/questions', question)
  return res.data
}

export const updateQuestion = async (question) => {
  console.log('Updating question:', question);
  const res = await axiosInstance.put(`/questions/${question.questionId}`, question);
  return res.data
}

export const deleteQuestion = async (questionId) => {
  await axiosInstance.delete(`/questions/${questionId}`)
  return true;
}